module.exports = __webpack_public_path__ + "img/11.c9cb970d.jpg";